import React from "react";
import { ChevronUpDownIcon } from "@heroicons/react/24/outline";
import DropdownLayoutV2 from "../DropdownLayoutV2";
import { ColorPicker, colorCodes } from "../../board/components/TaskDetail/ColorPicker";

export type ColorOption = {
  value: string;
  label: string;
  code: string;
  color?: string;
};

export type ColorFieldProps = {
  label?: string;
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  errorMessage?: string;
  className?: string;
  name?: string;
  options?: ColorOption[];
  showLabel?: boolean;
};

const ColorField: React.FC<ColorFieldProps> = ({
  label,
  value,
  onChange,
  placeholder,
  errorMessage,
  className,
  name,
  options = colorCodes,
  showLabel = true,
}) => {
  const matchedColor = options.find((option) => option.code === value);
  const selectedColor = matchedColor || {
    code: value,
    name: value,
    label: value,
  };
  const displayLabel = matchedColor
    ? (selectedColor as any)?.label || (selectedColor as any)?.name
    : value || placeholder || "Select color";

  const handleColorSelect = (colorItem: any) => {
    if (onChange) {
      onChange(colorItem.code);
    }
  };

  const activator = (
    <div className="bg-white border border-gray-200 rounded-lg w-full">
      <div className="flex items-center w-full">
        <div className="flex items-center gap-2 px-3 py-2.5">
          <span
            className="inline-block size-[26px] rounded-md"
            style={{
              backgroundColor: selectedColor?.code || "#6b7280",
            }}
          />
          <span className="text-[15px] font-medium text-gray-500">{displayLabel}</span>
        </div>
        <div className="flex-1" />
        <div className="px-3 py-2.5">
          <ChevronUpDownIcon className="w-3.5 h-3.5 text-gray-500" />
        </div>
      </div>
    </div>
  );

  return (
    <div className={`w-full ${className || ""}`}>
      {label && showLabel ? (
        <label className="block text-sm font-semibold text-gray-800 mb-2">{label}</label>
      ) : null}
      <div className="relative">
        <DropdownLayoutV2 activator={activator}>
          <ColorPicker
            pickerId={name || "color-field"}
            color={(selectedColor as any)?.color || selectedColor?.code}
            onSelectItem={handleColorSelect}
          />
        </DropdownLayoutV2>
      </div>
      {errorMessage ? <p className="mt-1 text-xs text-red-600">{errorMessage}</p> : null}
    </div>
  );
};

export default ColorField;
